module.exports = __webpack_public_path__ + "img/exam_jan_2025_h9vx4ryq.89441434.jpg";